import { noteToMidi } from '../utils/musicUtils';

export const mockSongs = [
    {
        id: '1',
        title: 'Tears',
        artist: '소찬휘',
        coverImage: 'https://image.bugsm.co.kr/album/images/500/41/4121.jpg',
        segments: [
            {
                difficulty: 'Hell',
                startSeconds: 0,
                lyrics: '잔인한 여자라 나를 욕하지는 마',
                notes: [
                    { pitch: noteToMidi('C5'), lyric: '잔' },
                    { pitch: noteToMidi('D5'), lyric: '인' },
                    { pitch: noteToMidi('D#5'), lyric: '한' },
                    { pitch: noteToMidi('C5'), lyric: '여' },
                    { pitch: noteToMidi('D5'), lyric: '자' },
                    { pitch: noteToMidi('D#5'), lyric: '라' },
                    { pitch: noteToMidi('C5'), lyric: '나' },
                    { pitch: noteToMidi('D#5'), lyric: '를' },
                    { pitch: noteToMidi('D5'), lyric: '욕' },
                    { pitch: noteToMidi('C5'), lyric: '하' },
                    { pitch: noteToMidi('A#4'), lyric: '지' },
                    { pitch: noteToMidi('G#4'), lyric: '이' },
                    { pitch: noteToMidi('A#4'), lyric: '는' },
                    { pitch: noteToMidi('A#4'), lyric: '마' },
                ],
            },
        ],
    },
    {
        id: '2',
        title: '좋은날',
        artist: '아이유',
        coverImage: 'https://image.bugsm.co.kr/album/images/500/2499/249930.jpg',
        segments: [
            {
                difficulty: 'Hell',
                startSeconds: 0,
                lyrics: "I'm in my dream",
                notes: [
                    { pitch: noteToMidi('A4'), lyric: "I'm" },
                    { pitch: noteToMidi('B4'), lyric: 'in' },
                    { pitch: noteToMidi('A4'), lyric: 'my' },
                    { pitch: noteToMidi('E5'), lyric: 'dre' },
                    { pitch: noteToMidi('F5'), lyric: 'drea' },
                    { pitch: noteToMidi('F#5'), lyric: 'dream' },
                ],
            },
        ],
    },
    {
        id: '3',
        title: "She's Gone",
        artist: 'Steelheart',
        coverImage: 'https://i.ytimg.com/vi/ICJs1CxCRt0/maxresdefault.jpg',
        segments: [
            {
                difficulty: 'Hell',
                startSeconds: 0,
                lyrics: "She's Gone~",
                notes: [
                    { pitch: noteToMidi('G4'), lyric: '거' },
                    { pitch: noteToMidi('B4'), lyric: '어' },
                    { pitch: noteToMidi('D5'), lyric: '어' },
                    { pitch: noteToMidi('G5'), lyric: '얼' },
                ],
            },
        ],
    },
    {
        id: '4',
        title: 'DRAWNING',
        artist: 'WOODS',
        coverImage: 'https://image.bugsm.co.kr/album/images/500/40839/4083984.jpg',
        segments: [
            {
                difficulty: 'Hard',
                startSeconds: 0,
                lyrics: 'BREATH',
                notes: [
                    { pitch: noteToMidi('G#4'), lyric: 'BRE' },
                    { pitch: noteToMidi('A#4'), lyric: 'BREA' },
                    { pitch: noteToMidi('C5'), lyric: 'BREATH' },
                ],
            },
        ],
    },
    {
        id: '5',
        title: 'My Way',
        artist: '이수',
        coverImage: 'https://image.bugsm.co.kr/album/images/500/201291/20129128.jpg',
        segments: [
            {
                difficulty: 'Extreme',
                startSeconds: 0,
                lyrics: '행여 그댈 맴돌아',
                notes: [
                    { pitch: noteToMidi('C5'), lyric: '행' },
                    { pitch: noteToMidi('C5'), lyric: '여' },
                    { pitch: noteToMidi('C5'), lyric: '그' },
                    { pitch: noteToMidi('A#4'), lyric: '댈' },
                    { pitch: noteToMidi('A#4'), lyric: '맴' },
                    { pitch: noteToMidi('C5'), lyric: '돌' },
                    { pitch: noteToMidi('D5'), lyric: '아' },
                ],
            },
        ],
    },
    {
        id: '6',
        title: '심(心)',
        artist: '얀',
        coverImage: '',
        segments: [
            {
                difficulty: 'Hard',
                startSeconds: 0,
                lyrics: '사랑하니까',
                notes: [
                    { pitch: noteToMidi('F#4'), lyric: '사' },
                    { pitch: noteToMidi('F4'), lyric: '랑' },
                    { pitch: noteToMidi('C#4'), lyric: '하' },
                    { pitch: noteToMidi('A#3'), lyric: '니' },
                    { pitch: noteToMidi('C#5'), lyric: '까' },
                ],
            },
        ],
    },
    {
        id: '7',
        title: 'Lonely Night',
        artist: '부활',
        coverImage: '',
        segments: [
            {
                difficulty: 'Extreme',
                startSeconds: 0,
                lyrics: '이유라면 이유일 수 있지만',
                notes: [
                    { pitch: noteToMidi('C#5'), lyric: '이' },
                    { pitch: noteToMidi('C#5'), lyric: '유' },
                    { pitch: noteToMidi('C#5'), lyric: '라' },
                    { pitch: noteToMidi('B4'), lyric: '면' },
                    { pitch: noteToMidi('A#4'), lyric: '이' },
                    { pitch: noteToMidi('A#4'), lyric: '유' },
                    { pitch: noteToMidi('A#4'), lyric: '일' },
                    { pitch: noteToMidi('C#5'), lyric: '수' },
                    { pitch: noteToMidi('B4'), lyric: '있' },
                    { pitch: noteToMidi('A#4'), lyric: '지' },
                    { pitch: noteToMidi('F#4'), lyric: '만' },
                ],
            },
        ],
    },
    {
        id: '8',
        title: 'Dont Cry',
        artist: '더크로스',
        coverImage: '',
        segments: [
            {
                difficulty: 'Hell',
                startSeconds: 0,
                lyrics: '이젠 안녕, 영원히',
                notes: [
                    { pitch: noteToMidi('A4'), lyric: '이' },
                    { pitch: noteToMidi('A#4'), lyric: '젠' },
                    { pitch: noteToMidi('A#4'), lyric: '안' },
                    { pitch: noteToMidi('C5'), lyric: '녕' },
                    { pitch: noteToMidi('F5'), lyric: '영' },
                    { pitch: noteToMidi('E5'), lyric: '원' },
                    { pitch: noteToMidi('F5'), lyric: '히' },
                ],
            },
        ],
    },
    {
        id: '9',
        title: '진달래꽃',
        artist: '마야',
        coverImage: '',
        segments: [
            {
                difficulty: 'Extreme',
                startSeconds: 0,
                lyrics: '그댄 그녈 사랑하겠지',
                notes: [
                    { pitch: noteToMidi('F4'), lyric: '그' },
                    { pitch: noteToMidi('F4'), lyric: '댄' },
                    { pitch: noteToMidi('F4'), lyric: '그' },
                    { pitch: noteToMidi('A4'), lyric: '녈' },
                    { pitch: noteToMidi('A4'), lyric: '사' },
                    { pitch: noteToMidi('A4'), lyric: '랑' },
                    { pitch: noteToMidi('B4'), lyric: '하' },
                    { pitch: noteToMidi('C5'), lyric: '겠' },
                    { pitch: noteToMidi('E5'), lyric: '지' },
                ],
            },
        ],
    },
    {
        id: '10',
        title: 'Golden',
        artist: 'huntrix',
        coverImage: 'https://i1.sndcdn.com/artworks-X5E1zHWMoZEwq8nx-A0apww-t500x500.png',
        segments: [
            {
                difficulty: 'Hell',
                startSeconds: 0,
                lyrics: "I'm done hidin now I'm shining like I'm born to be",
                notes: [
                    { pitch: noteToMidi('E4'), lyric: '암' },
                    { pitch: noteToMidi('G4'), lyric: '돈' },
                    { pitch: noteToMidi('C5'), lyric: '하이' },
                    { pitch: noteToMidi('B4'), lyric: '린' },
                    { pitch: noteToMidi('D4'), lyric: '나우' },
                    { pitch: noteToMidi('F#4'), lyric: '암' },
                    { pitch: noteToMidi('E5'), lyric: '샤이' },
                    { pitch: noteToMidi('D5'), lyric: '닝' },
                    { pitch: noteToMidi('G4'), lyric: '라이크' },
                    { pitch: noteToMidi('B4'), lyric: '암' },
                    { pitch: noteToMidi('A5'), lyric: '본' },
                    { pitch: noteToMidi('F#5'), lyric: '투' },
                    { pitch: noteToMidi('G5'), lyric: '비' },
                    { pitch: noteToMidi('E5'), lyric: '이' },                    
                ],
            },
        ],
    },
    {
        id: '11',
        title: '눈사람',
        artist: '정승환',
        coverImage: '',
        segments: [
            {
                difficulty: 'Normal',
                startSeconds: 0,
                lyrics: "마지막으로 날",
                notes: [
                    { pitch: noteToMidi('A4'), lyric: '마' },
                    { pitch: noteToMidi('A4'), lyric: '지' },
                    { pitch: noteToMidi('G4'), lyric: '막' },
                    { pitch: noteToMidi('A4'), lyric: '으' },
                    { pitch: noteToMidi('A#4'), lyric: '로' },
                    { pitch: noteToMidi('F4'), lyric: '날' },                   
                ],
            },
        ],
    },
    {
        id: '12',
        title: '모르시나요',
        artist: '조째즈',
        coverImage: '',
        segments: [
            {
                difficulty: 'Normal',
                startSeconds: 0,
                lyrics: "기다리는 나를 왜 모르시나요",
                notes: [
                    { pitch: noteToMidi('C4'), lyric: '기' },
                    { pitch: noteToMidi('A4'), lyric: '다' },
                    { pitch: noteToMidi('G4'), lyric: '리' },
                    { pitch: noteToMidi('F4'), lyric: '는' },
                    { pitch: noteToMidi('G4'), lyric: '나' },
                    { pitch: noteToMidi('F4'), lyric: '를' },
                    { pitch: noteToMidi('F4'), lyric: '왜' },
                    { pitch: noteToMidi('F4'), lyric: '모' },
                    { pitch: noteToMidi('G4'), lyric: '르' },
                    { pitch: noteToMidi('A4'), lyric: '시' },
                    { pitch: noteToMidi('F4'), lyric: '나' },
                    { pitch: noteToMidi('G4'), lyric: '요' },                    
                ],
            },
        ],
    },
    {
        id: '13',
        title: 'Endless Rain',
        artist: 'X Japan',
        coverImage: '',
        segments: [
            {
                difficulty: 'Hard',
                startSeconds: 0,
                lyrics: "Endless Rain, Fall of ",
                notes: [
                    { pitch: noteToMidi('D#4'), lyric: '엔' },
                    { pitch: noteToMidi('A#4'), lyric: '드리스' },
                    { pitch: noteToMidi('B4'), lyric: '레인' },
                    { pitch: noteToMidi('C#5'), lyric: '폴' },
                    { pitch: noteToMidi('B4'), lyric: '온' },
                    { pitch: noteToMidi('A#4'), lyric: '마이' },
                    { pitch: noteToMidi('B4'), lyric: '하트' },                
                ],
            },
        ],
    },
];